// Display · EntitySelectContext
//
// Holds a render function for entity-select dropdowns so that `tables/`
// components can render interactive entity selects WITHOUT importing from
// `connected/` (which is above them in the tier order).
//
// Default renderer: null (no-op placeholder span).
// Connected provider: `@ds/connected/EntitySelectProvider` injects the real
// `EntitySelect` component so all interaction works in the running app.

import React, { type ReactNode } from "react";
import {
  EntitySelectContext,
  type EntitySelectRenderer,
} from "@ds/display/entitySelectRendererContext";

export type {
  EntitySelectRenderer,
  EntitySelectRendererProps,
} from "@ds/display/entitySelectRendererContext";

// ─── Provider (used by connected/EntitySelectProvider) ──────────────────────

export interface EntitySelectContextProviderProps {
  renderer: EntitySelectRenderer;
  children: ReactNode;
}

export function EntitySelectContextProvider({
  renderer,
  children,
}: EntitySelectContextProviderProps): React.ReactElement {
  return (
    <EntitySelectContext.Provider value={renderer}>
      {children}
    </EntitySelectContext.Provider>
  );
}
